import * as Types from './types';

export default {
  setNotiMessage: notiMessage =>
    async dispatch => dispatch({ type: Types.SET_NOTI_MESSAGE, notiMessage }),
};
